import { createContext, useContext, useState } from 'react';

const HostContext = createContext();

const initialState = {
  selectedTab: 'upcoming',
  selectedExpandedCard: null,
};

const initialFilterState = {
  yearMonth: new Date(),
};

const HostProvider = ({ children }) => {
  const [state, setState] = useState(initialState);
  const [filterState, setFilterState] = useState(initialFilterState);

  const updateState = (payload) => setState((prev) => ({ ...prev, ...payload }));
  const updateFilterState = (payload) => setFilterState((prev) => ({ ...prev, ...payload }));
  const resetState = () => setState(initialState);
  const resetFilterState = () => setFilterState(initialFilterState);

  return <HostContext.Provider value={{ updateState, updateFilterState, resetState, resetFilterState, state, filterState }}>{children}</HostContext.Provider>;
};

export const useHostState = () => {
  return useContext(HostContext);
};

export default HostProvider;
